module.exports = require('./src/wheel-swipe.js');